"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchExtraPrices = void 0;
var _getOfferExtraPricesDetailsWeb = require("../../repositories/public/newbuilding-promos/v1/get-offer-extra-prices-details-web");
var _peperrors = require("@cian/peperrors");
const fetchExtraPrices = async _ref => {
  let {
    offerId,
    httpApi
  } = _ref;
  const response = await (0, _getOfferExtraPricesDetailsWeb.fetchGetOfferExtraPricesDetailsWeb)({
    httpApi,
    parameters: {
      offerId
    }
  });
  if (response.statusCode !== 200) {
    throw new _peperrors.HttpBadStatusCodeError({
      statusCode: response.statusCode,
      message: response.response.message,
      domain: 'src/services/fetchExtraPrices/fetchExtraPrices.ts'
    });
  }
  if (!response.response.extraPricesDetails) {
    throw new _peperrors.NotFoundError({
      message: 'Extra prices details not found',
      domain: 'src/services/fetchExtraPrices/fetchExtraPrices.ts'
    });
  }
  return response.response.extraPricesDetails;
};
exports.fetchExtraPrices = fetchExtraPrices;